import moment from 'moment'

/**
 * Detects whether the current Moment.js locale uses a 12-hour time format (AM/PM).
 *
 * The function checks the localized time format (`LT`) defined in Moment.js
 * and determines if it contains an AM/PM marker (`A` or `a`).
 *
 * Example:
 * - `h:mm A` → 12-hour format (AM/PM)
 * - `HH:mm` → 24-hour format
 *
 * @function is12HourMoment
 * @returns {boolean} Returns `true` if the locale uses a 12-hour time format (AM/PM),
 * otherwise `false` if it uses a 24-hour format.
 *
 * @example
 * const is12h = is12HourMoment()
 *
 * if (is12h) {
 *   console.log('User locale uses AM/PM format')
 * } else {
 *   console.log('User locale uses 24-hour format')
 * }
 */
export function is12HourMoment() {
  const format = moment.localeData().longDateFormat('LT')
  return /A/i.test(format)
}
